<template lang="pug">
.target-other-user-detail-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：施設関係者グループ
    template(#cell(groupName)="row")
      span {{ row.item.name }}（{{ row.item.groupTypeName }}）
    // セル：施設関係者メンバー
    template(#cell(memberName)="row")
      span {{ row.item.memberName }}（{{ row.item.memberOrganization }}）
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 文書送付、確認・同意ユーザー一覧テーブル
 */
@Component({})
export default class TargetOtherUserDetailTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<TargetOtherUserDetailTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<TargetOtherUserDetailTableField>;

  get _value(): Array<TargetOtherUserDetailTableItem> {
    return this.value;
  }

  public convertDateText(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
    return date;
  }
}

/** テーブルの列名の情報 */
export interface TargetOtherUserDetailTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface TargetOtherUserDetailTableItem {
  /** 施設関係者グループソートキー */
  otherUserGroupsSortKey: string;
  /** グループを一意に識別する ID */
  id: number;
  /** グループ名 */
  name: string;
  /** グループの種類の ID。otherUserGroupTypes の id とひもづく */
  groupTypeId: number;
  /** グループ種類名 */
  groupTypeName: string;
  /** グループ内のメンバーを一意に識別する ID */
  memberId: number;
  /** メンバー名 */
  memberName: string;
  /** メンバー電話番号 */
  memberTel: string;
  /** メンバー所属 */
  memberOrganization: string;
  /** メンバーのLINE の ID */
  memberLineId: string | null;
  /** メンバーのメールアドレス */
  memberMailaddress: string | null;
}
</script>
